module.exports = __webpack_public_path__ + "img/quiz-meditation.fda265e6.png";